import { CAPTURE_CONFIG } from './config';

// Which viewer frame goes into each GIF frame.
// GIF time is game time (64 ticks per second), whatever the viewer's playback speed.
const TICKS_PER_SECOND = 64;

// The index of the last frame whose tick is <= target (frames are sorted by tick).
function lastAtOrBefore(frames, target) {
  let low = 0;
  let high = frames.length - 1;
  while (low < high) {
    const mid = Math.ceil((low + high) / 2);
    if (frames[mid].tick <= target) low = mid;
    else high = mid - 1;
  }
  return low;
}

// placement: 'centred' | 'starting'. Returns one frame index per GIF frame.
// eslint-disable-next-line import-x/prefer-default-export
export function planGifFrames(frames, currentFrameIndex, { lengthS, placement, fps }) {
  const firstTick = frames[0].tick;
  const lastTick = frames[frames.length - 1].tick;
  const roundS = (lastTick - firstTick) / TICKS_PER_SECOND;
  // A round shorter than the length is covered whole.
  const seconds = Math.min(lengthS, CAPTURE_CONFIG.gif.maxLengthS, roundS);
  const count = Math.max(1, Math.round(seconds * fps));
  const targetOffset = (i) => Math.round((i * TICKS_PER_SECOND) / fps);

  const currentTick = frames[currentFrameIndex].tick;
  const wanted = placement === 'centred'
    ? currentTick - (seconds * TICKS_PER_SECOND) / 2
    : currentTick;
  // Shifted, never shortened, to fit inside the round.
  const startTick = Math.max(firstTick, Math.min(wanted, lastTick - targetOffset(count - 1)));

  return Array.from(
    { length: count },
    (_, i) => lastAtOrBefore(frames, startTick + targetOffset(i)),
  );
}
